module.exports = __webpack_public_path__ + "img/logo_sc_mobi_novo.bafa3f7c.png";